<template>
  <router-view class="loading"/>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route': function(to,from){
　    document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue